import { render, staticRenderFns } from "./HousingCover.vue?vue&type=template&id=7b8c85be&scoped=true"
import script from "./HousingCover.vue?vue&type=script&lang=js"
export * from "./HousingCover.vue?vue&type=script&lang=js"
import style0 from "./HousingCover.vue?vue&type=style&index=0&id=7b8c85be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8c85be",
  null
  
)

export default component.exports